var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{ref:"ht-loading",class:[_vm.dialog?'ht-loading':'ht-loading2']},[_c('div',{staticClass:"ht-loading-shade"}),_vm._v(" "),_c('div',{staticClass:"ht-loading-content"},[_c('img',{attrs:{"src":require("@/assets/images/loading-srcl.gif")}}),_vm._v(" "),(_vm.name)?_c('label',[_vm._v(_vm._s(_vm.name)+"...")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b7ef76a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/ht-loading.vue
// module id = null
// module chunks = 